import React, { useEffect, useState } from "react"
import { motion } from "framer-motion"
import { Trans, useTranslation } from "react-i18next"
import {
  routerPage,
  routerPageDesktop,
  routerTransition,
  routerTransitionDesktop,
} from "../Utils/PageTransition"
import { isAuth, logout } from "../Utils/FirebaseUtils"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { t } from "i18next"
import { faNewspaper } from "@fortawesome/free-regular-svg-icons"
import {
  faComments,
  faLanguage,
  faPeopleGroup,
  faRightFromBracket,
  faTag,
  faUsers,
  faVial,
} from "@fortawesome/free-solid-svg-icons"

import { getMember } from "../HelpingFunction/Member/memberDBHelper"
import { getRole, getUserLang } from "../Utils/utiltyHelper"
import { ROLE } from "../Enum/APP_TYPE"
import SettingMenu, {
  SettingMenuItem,
} from "../page-components/setting/SettingMenu"
import { GCMManager } from "../page-components/setting/GCMManager"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const Setting: React.FC = (props) => {
  const { i18n } = useTranslation()
  const history = useHistory()
  const location = useLocation()

  const auth = useSelector((state: any) => {
    return state.firebase.auth
  })

  const screenWidth = useSelector((state: any) => {
    return state.SystemManager.screenWidth
  })

  const [role, setRole] = useState<ROLE | "">("")
  const [myProfile, setMyProfile] = useState({})
  const [isLoadedProfile, setIsLoadedProfile] = useState<boolean>(false)

  useEffect(() => {
    if (isAuth(auth) && !isLoadedProfile) {
      getMember(auth.uid).then((result) => {
        if (result.success) {
          setMyProfile(result.data)
          setIsLoadedProfile(true)
        }
      })
      const getRoleFn = async () => {
        const role = await getRole()
        setRole(role)
      }

      getRoleFn()
    }
  }, [auth])

  const SettingMenuItems: SettingMenuItem[] = [
    {
      icon: faPeopleGroup,
      title: t("AppSetting.about"),
      path: "about",
    },
    {
      icon: faNewspaper,
      title: t("AppSetting.blog"),
      path: "blog",
    },
    {
      icon: faLanguage,
      title: t("AppSetting.language"),
      path: "setting",
      onClick: () => {
        const newLang = getUserLang() === "en" ? "hk" : "en"
        i18n.changeLanguage(newLang)
        localStorage.setItem("i18n-lang", newLang)
      },
    },
    {
      icon: faTag,
      title: t("BottomAppBar.kol-pro"),
      path: "kol-pro",
      hidden: role !== ROLE.KOL,
    },
    {
      icon: faComments,
      title: t("AppSetting.marketing"),
      path: "setting",
      hidden: role !== ROLE.CUSTOMER,
      onClick: () => {
        window.open("https://calendly.com/look4kol/look4kol")
      },
    },
  ]

  return (
    <motion.div
      initial="out"
      exit="out"
      animate="in"
      variants={screenWidth < 768 ? routerPage : routerPageDesktop}
      transition={
        screenWidth < 768 ? routerTransition : routerTransitionDesktop
      }>
      <div className="max-w-5xl mx-auto">
        <h1 className="md:px-0 px-4 mt-12 mb-4 text-gray-800 text-3xl font-semibold">
          <Trans>AppSetting.title</Trans>
        </h1>

        <section>
          <SettingMenu items={SettingMenuItems} />
        </section>
        <hr />
        <section className="max-w-7xl mx-auto my-4 px-4 sm:px-6 lg:px-8">
          <h2 className="text-gray-700 text-lg font-black mb-6">
            <Trans>AppSetting.test-messaging</Trans>
            <FontAwesomeIcon icon={faVial} className="text-gray-500 mx-2" />
          </h2>
          <GCMManager />
        </section>

        {isAuth(auth) && (
          <button
            className="  text-red-700 text-base px-2 py-1 w-full mx-auto mt-12"
            onClick={() => {
              logout()

              let params = new URLSearchParams("")
              if (location.search.includes("viewAs")) {
                params.append("returnToCustomer", "true")
              }
              history.push({
                pathname: "/" + getUserLang() + "/login",
                search: params.toString(),
              })
            }}>
            <FontAwesomeIcon className="mx-2" icon={faRightFromBracket} />
            <Trans>Heading.logout</Trans>
          </button>
        )}
      </div>
    </motion.div>
  )
}

export default Setting
